<template>
  <div v-if="podeConsultar" class="risco-cliente-grupo">
    <button
      type="button"
      class="btn btn-primary btn-sm d-inline-flex align-items-center"
      aria-label="Consultar inadimplência no grupo"
      title="Consultar inadimplência no grupo (F8)"
      v-b-tooltip.hover.top
      @click="abrir"
    >
      <AccountSearch :size="18" />
      <span class="ml-2 font-size-xs font-weight-bolder">– F8</span>
    </button>

    <b-modal
      ref="modal"
      title="Visão do cliente no grupo"
      hide-footer
      scrollable
      :hide-header-close="false"
      :no-close-on-esc="false"
      modal-class="risco-cliente-grupo-modal"
      dialog-class="risco-cliente-grupo-dialog"
      content-class="risco-cliente-grupo-conteudo"
      @hidden="empresaDetalheId = null"
    >
      <div v-if="carregando" class="text-center py-12">
        <b-spinner variant="primary" />
        <div class="text-muted mt-3">Consultando o histórico financeiro...</div>
      </div>

      <b-alert v-else-if="erro" show variant="light-danger">
        <div class="d-flex align-items-center justify-content-between">
          <span>{{ erro }}</span>
          <b-button size="sm" variant="danger" @click="consultar">
            Tentar novamente
          </b-button>
        </div>
      </b-alert>

      <template v-else-if="consulta">
        <div class="cliente-risco-cabecalho rounded p-4 mb-5">
          <div class="text-muted font-size-sm">Cliente consultado</div>
          <strong>{{ consulta.cliente.nome }}</strong>
          <span class="text-muted ml-2">{{ formatarDocumento(consulta.cliente.cnpj_cpf) }}</span>
          <div class="text-muted font-size-sm mt-1">{{ consulta.aviso }}</div>
        </div>

        <b-tabs v-model="abaAtiva" pills lazy @input="aoAlterarAba">
          <b-tab title="Risco financeiro">
            <b-row class="my-5">
          <b-col lg="3" class="mb-4 mb-lg-0">
            <div class="score-card h-100 border rounded p-5 text-center">
              <div class="text-muted text-uppercase font-size-sm">Score operacional</div>
              <div class="score-valor my-2" :class="classeScore(consulta.score.nivel)">
                {{ consulta.score.valor }}
              </div>
              <span class="label label-inline" :class="classeLabel(consulta.score.nivel)">
                {{ consulta.score.descricao }}
              </span>
              <b-progress
                class="mt-4"
                height="8px"
                :value="consulta.score.valor"
                :max="1000"
                :variant="varianteScore(consulta.score.nivel)"
              />
            </div>
          </b-col>
          <b-col lg="9">
            <b-row>
              <b-col sm="6" xl="3" class="mb-3">
                <div class="resumo-card border rounded p-4 h-100">
                  <div class="text-muted font-size-sm">Total vencido</div>
                  <strong class="font-size-h4 text-danger">
                    {{ formatarMoeda(consulta.totais.total_vencido) }}
                  </strong>
                </div>
              </b-col>
              <b-col sm="6" xl="3" class="mb-3">
                <div class="resumo-card border rounded p-4 h-100">
                  <div class="text-muted font-size-sm">Títulos vencidos</div>
                  <strong class="font-size-h4">{{ consulta.totais.quantidade_vencida }}</strong>
                </div>
              </b-col>
              <b-col sm="6" xl="3" class="mb-3">
                <div class="resumo-card border rounded p-4 h-100">
                  <div class="text-muted font-size-sm">Maior atraso</div>
                  <strong class="font-size-h4">
                    {{ consulta.totais.maior_atraso_dias }} dias
                  </strong>
                </div>
              </b-col>
              <b-col sm="6" xl="3" class="mb-3">
                <div class="resumo-card border rounded p-4 h-100">
                  <div class="text-muted font-size-sm">Empresas afetadas</div>
                  <strong class="font-size-h4">
                    {{ consulta.totais.empresas_com_inadimplencia }}
                  </strong>
                </div>
              </b-col>
            </b-row>
            <div class="score-explicacao border rounded px-4 py-3 mt-1 d-flex align-items-center">
              <div>
                <strong>Score interno</strong>
                <span class="text-muted font-size-sm ml-2">Escala de 0 a 1.000</span>
              </div>
              <button
                :id="ajudaScoreId"
                type="button"
                class="btn btn-icon btn-light-primary btn-sm ml-2"
                aria-label="Entenda o cálculo do score"
              >
                <InformationOutline :size="17" />
              </button>
              <b-popover
                :target="ajudaScoreId"
                triggers="click blur"
                placement="bottom"
                custom-class="score-ajuda-popover"
              >
                <template #title>Como o score foi calculado?</template>
                <p class="font-size-sm mb-2">
                  Começa com 1.000 pontos e diminui conforme a inadimplência do grupo.
                </p>
                <ul class="font-size-sm pl-4 mb-3">
                  <li v-for="regra in consulta.metodologia.regras" :key="regra">
                    {{ regra }}
                  </li>
                </ul>
                <div class="font-size-sm border-top pt-2">
                  <strong>Descontos desta consulta</strong>
                  <div>Atraso: -{{ consulta.score.penalidades.atraso }}</div>
                  <div>Títulos: -{{ consulta.score.penalidades.quantidade }}</div>
                  <div>Proporção vencida: -{{ consulta.score.penalidades.proporcao }}</div>
                </div>
                <div class="font-size-xs text-muted border-top mt-2 pt-2">
                  0–300 Baixo · 301–500 Regular · 501–700 Bom · 701–1.000 Excelente
                </div>
                <div class="font-size-xs text-muted mt-2">
                  Análise interna; não representa consulta Serasa, SPC ou Cadastro Positivo.
                </div>
              </b-popover>
            </div>
          </b-col>
            </b-row>

            <div class="table-responsive border rounded">
          <table class="table table-head-custom table-vertical-center mb-0">
            <thead>
              <tr>
                <th>Empresa</th>
                <th>Cadastro localizado</th>
                <th class="text-center">Score</th>
                <th>Status</th>
                <th class="text-right">Em aberto</th>
                <th class="text-right">Vencidos</th>
                <th class="text-right">Total vencido</th>
                <th class="text-right">Maior atraso</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in consulta.empresas">
                <tr :key="`empresa-${item.empresa.id_empresa}`">
                  <td><strong>{{ item.empresa.nome }}</strong></td>
                  <td>
                    <template v-if="item.cliente_localizado">
                      <div v-for="clienteItem in item.clientes" :key="clienteItem.id_pessoa">
                        {{ clienteItem.nome }}
                      </div>
                    </template>
                    <span v-else class="label label-inline label-warning">
                      Não cadastrado
                    </span>
                  </td>
                  <td class="text-center font-weight-bolder">
                    {{ item.score ? item.score.valor : "—" }}
                  </td>
                  <td>
                    <span
                      v-if="item.score"
                      class="label label-inline"
                      :class="classeLabel(item.score.nivel)"
                    >
                      {{ item.score.descricao }}
                    </span>
                    <span v-else class="text-muted">Sem dados</span>
                  </td>
                  <td class="text-right">{{ formatarMoeda(item.total_aberto) }}</td>
                  <td class="text-right">{{ item.quantidade_vencida }}</td>
                  <td class="text-right font-weight-bold" :class="item.total_vencido > 0 ? 'text-danger' : ''">
                    {{ formatarMoeda(item.total_vencido) }}
                  </td>
                  <td class="text-right text-nowrap">
                    {{ item.maior_atraso_dias }} dias
                    <button
                      v-if="item.titulos_vencidos.length"
                      type="button"
                      class="btn btn-link btn-sm py-0 pr-0"
                      @click="alternarDetalhes(item.empresa.id_empresa)"
                    >
                      {{ empresaDetalheId === item.empresa.id_empresa ? "Ocultar" : "Ver títulos" }}
                    </button>
                  </td>
                </tr>
                <tr
                  v-if="empresaDetalheId === item.empresa.id_empresa"
                  :key="`detalhes-${item.empresa.id_empresa}`"
                  class="titulos-detalhes"
                >
                  <td colspan="8" class="p-4">
                    <div class="table-responsive bg-white border rounded">
                      <table class="table table-sm mb-0">
                        <thead>
                          <tr>
                            <th>Documento</th>
                            <th>Histórico</th>
                            <th>Vencimento</th>
                            <th class="text-right">Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="titulo in item.titulos_vencidos" :key="titulo.id">
                            <td>{{ titulo.documento || "—" }}</td>
                            <td>{{ titulo.historico || "—" }}</td>
                            <td>{{ formatarData(titulo.data_vencimento) }}</td>
                            <td class="text-right text-danger font-weight-bold">
                              {{ formatarMoeda(titulo.valor) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
            </div>
          </b-tab>

          <b-tab title="Sugestões de recompra">
            <div v-if="carregandoCompras" class="text-center py-12">
              <b-spinner variant="primary" />
              <div class="text-muted mt-3">Analisando as compras nas empresas do grupo...</div>
            </div>

            <b-alert v-else-if="erroCompras" show variant="light-danger" class="mt-5">
              <div class="d-flex align-items-center justify-content-between">
                <span>{{ erroCompras }}</span>
                <b-button size="sm" variant="danger" @click="consultarCompras(true)">
                  Tentar novamente
                </b-button>
              </div>
            </b-alert>

            <template v-else-if="compras">
              <b-row class="mt-5 mb-2">
                <b-col sm="6" xl="3" class="mb-3">
                  <div class="resumo-card border rounded p-4 h-100">
                    <div class="text-muted font-size-sm">Movimentações analisadas</div>
                    <strong class="font-size-h4">
                      {{ compras.resumo.quantidade_movimentacoes || compras.resumo.quantidade_compras }}
                    </strong>
                  </div>
                </b-col>
                <b-col sm="6" xl="3" class="mb-3">
                  <div class="resumo-card border rounded p-4 h-100">
                    <div class="text-muted font-size-sm">Valor concluído</div>
                    <strong class="font-size-h4">
                      {{ formatarMoeda(compras.resumo.valor_comprado) }}
                    </strong>
                  </div>
                </b-col>
                <b-col sm="6" xl="3" class="mb-3">
                  <div class="resumo-card border rounded p-4 h-100">
                    <div class="text-muted font-size-sm">Empresas visitadas</div>
                    <strong class="font-size-h4">
                      {{ compras.resumo.empresas_com_compras }}
                    </strong>
                  </div>
                </b-col>
                <b-col sm="6" xl="3" class="mb-3">
                  <div class="resumo-card border rounded p-4 h-100">
                    <div class="text-muted font-size-sm">Última movimentação</div>
                    <strong class="font-size-h4">
                      {{ formatarData(compras.resumo.ultima_compra) }}
                    </strong>
                  </div>
                </b-col>
              </b-row>

              <b-alert show variant="light" class="border mb-4">
                O histórico reúne todas as movimentações. Para não contar a mesma negociação
                mais de uma vez, as sugestões usam somente documentos concluídos ou faturados
                nos últimos {{ compras.periodo_meses }} meses.
              </b-alert>

              <div v-if="compras.sugestoes.length" class="row">
                <div
                  v-for="sugestao in compras.sugestoes"
                  :key="chaveSugestao(sugestao)"
                  class="col-xl-6 mb-4"
                >
                  <div class="sugestao-recompra border rounded p-5 h-100">
                    <div class="d-flex justify-content-between align-items-start mb-3">
                      <div class="pr-3">
                        <strong class="font-size-lg">
                          {{ sugestao.produto.descricao }}
                        </strong>
                        <div class="text-muted font-size-sm">
                          {{ identificacaoProduto(sugestao.produto) }}
                        </div>
                      </div>
                      <span
                        class="label label-inline text-nowrap"
                        :class="classeSituacaoRecompra(sugestao.situacao)"
                      >
                        {{ sugestao.descricao_situacao }}
                      </span>
                    </div>
                    <div class="font-size-sm mb-3">
                      Comprado <strong>{{ sugestao.quantidade_compras }} vezes</strong>, em média
                      a cada <strong>{{ sugestao.intervalo_medio_dias }} dias</strong>.
                    </div>
                    <div class="recompra-ultima rounded p-3">
                      Há <strong>{{ sugestao.dias_desde_ultima_compra }} dias</strong>, o cliente
                      comprou este produto na
                      <strong>{{ sugestao.ultima_empresa.nome }}</strong>.
                    </div>
                    <div class="d-flex justify-content-between text-muted font-size-sm mt-3">
                      <span>Última: {{ formatarData(sugestao.ultima_compra) }}</span>
                      <span>Previsão: {{ formatarData(sugestao.proxima_compra_estimada) }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <b-alert v-else show variant="light-warning">
                Ainda não há compras repetidas suficientes para sugerir uma recompra.
                Consulte a aba “Histórico de compras” para visualizar os itens encontrados.
              </b-alert>
            </template>
          </b-tab>

          <b-tab title="Histórico de compras">
            <div v-if="carregandoCompras" class="text-center py-12">
              <b-spinner variant="primary" />
              <div class="text-muted mt-3">Buscando as compras do cliente...</div>
            </div>

            <b-alert v-else-if="erroCompras" show variant="light-danger" class="mt-5">
              {{ erroCompras }}
            </b-alert>

            <template v-else-if="compras">
              <div class="d-flex flex-wrap align-items-center justify-content-between my-5">
                <div>
                  <strong>Compras nas empresas do grupo</strong>
                  <div class="text-muted font-size-sm">{{ compras.aviso }}</div>
                </div>
                <div class="historico-pesquisa mt-3 mt-md-0">
                  <b-form-input
                    v-model.trim="filtroHistorico"
                    size="sm"
                    placeholder="Filtrar produto ou empresa"
                  />
                </div>
              </div>

              <div class="table-responsive border rounded">
                <table class="table table-head-custom table-vertical-center mb-0">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Empresa</th>
                      <th>Tipo</th>
                      <th>Documento</th>
                      <th>Produto</th>
                      <th class="text-right">Quantidade</th>
                      <th class="text-right">Valor unitário</th>
                      <th class="text-right">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in historicoFiltrado" :key="chaveHistorico(item)">
                      <td class="text-nowrap">
                        {{ formatarData(item.data) }}
                        <div class="text-muted font-size-xs">há {{ item.dias_desde }} dias</div>
                      </td>
                      <td><strong>{{ item.empresa.nome }}</strong></td>
                      <td>
                        <span
                          class="label label-inline text-nowrap"
                          :class="classeTipoMovimento(item.origem)"
                        >
                          {{ item.tipo }}
                        </span>
                      </td>
                      <td class="text-nowrap">
                        Nº {{ item.numero_documento || item.numero_nota || "—" }}
                        <div class="text-muted font-size-xs">
                          {{ item.status ? item.status.descricao : "—" }}
                        </div>
                      </td>
                      <td>
                        <strong>{{ item.produto.descricao }}</strong>
                        <div class="text-muted font-size-xs">
                          {{ identificacaoProduto(item.produto) }}
                        </div>
                      </td>
                      <td class="text-right">{{ formatarQuantidade(item.quantidade) }}</td>
                      <td class="text-right">{{ formatarMoeda(item.valor_unitario) }}</td>
                      <td class="text-right font-weight-bold">
                        {{ formatarMoeda(item.valor_total) }}
                      </td>
                    </tr>
                    <tr v-if="!historicoFiltrado.length">
                      <td colspan="8" class="text-center text-muted py-8">
                        Nenhuma compra encontrada para o filtro informado.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </b-tab>
        </b-tabs>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AccountSearch from "vue-material-design-icons/AccountSearch.vue";
import InformationOutline from "vue-material-design-icons/InformationOutline.vue";

export default {
  name: "RiscoClienteGrupo",
  components: {
    AccountSearch,
    InformationOutline,
  },
  props: {
    cliente: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      carregando: false,
      erro: "",
      consulta: null,
      empresaDetalheId: null,
      abaAtiva: 0,
      carregandoCompras: false,
      erroCompras: "",
      compras: null,
      filtroHistorico: "",
    };
  },
  computed: {
    ...mapGetters(["empresaContexto", "empresas"]),
    ajudaScoreId() {
      return `ajuda-score-cliente-${this._uid}`;
    },
    documento() {
      return String(this.cliente?.cnpj_cpf || "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    },
    empresasDoGrupo() {
      const grupoId = Number(this.empresaContexto?.id_grupo_empresa || 0);

      return (this.empresas || []).filter(
        (empresa) => Number(empresa.id_grupo_empresa || 0) === grupoId
      );
    },
    documentoValido() {
      return /^\d{11}$/.test(this.documento) || /^[A-Z0-9]{14}$/.test(this.documento);
    },
    podeConsultar() {
      return (
        Number(this.cliente?.id_pessoa || 0) > 0 &&
        this.documentoValido &&
        Number(this.empresaContexto?.id_grupo_empresa || 0) > 0 &&
        this.empresasDoGrupo.length > 1
      );
    },
    historicoFiltrado() {
      const historico = this.compras?.historico || [];
      const termo = String(this.filtroHistorico || "")
        .toLocaleLowerCase("pt-BR")
        .trim();

      if (!termo) return historico;

      return historico.filter((item) => {
        const conteudo = [
          item.empresa?.nome,
          item.produto?.descricao,
          item.produto?.referencia,
          item.produto?.cod_barras,
          item.produto?.codigo,
          item.numero_nota,
        ]
          .filter(Boolean)
          .join(" ")
          .toLocaleLowerCase("pt-BR");

        return conteudo.includes(termo);
      });
    },
  },
  watch: {
    "cliente.id_pessoa"() {
      this.consulta = null;
      this.erro = "";
      this.empresaDetalheId = null;
      this.abaAtiva = 0;
      this.compras = null;
      this.erroCompras = "";
      this.filtroHistorico = "";
    },
  },
  mounted() {
    window.addEventListener("keydown", this.abrirPeloAtalho);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.abrirPeloAtalho);
  },
  methods: {
    abrirPeloAtalho(event) {
      if (event.key !== "F8" || event.repeat || !this.podeConsultar) return;

      event.preventDefault();
      event.stopPropagation();
      this.abrir();
    },
    async abrir() {
      this.abaAtiva = 0;
      this.$refs.modal.show();
      await this.consultar();
    },
    async consultar() {
      this.carregando = true;
      this.erro = "";

      try {
        const response = await this.$http.post("/empresa/grupo/clientes/risco", {
          id_pessoa: Number(this.cliente.id_pessoa),
        });
        this.consulta = response.data.data;
      } catch (error) {
        this.consulta = null;
        this.erro =
          error?.response?.data?.message ||
          "Não foi possível consultar o risco financeiro agora.";
      } finally {
        this.carregando = false;
      }
    },
    aoAlterarAba(indice) {
      if (Number(indice) > 0) {
        this.consultarCompras();
      }
    },
    async consultarCompras(forcar = false) {
      if ((this.compras && !forcar) || this.carregandoCompras) return;

      this.carregandoCompras = true;
      this.erroCompras = "";

      try {
        const response = await this.$http.post("/empresa/grupo/clientes/compras", {
          id_pessoa: Number(this.cliente.id_pessoa),
        });
        this.compras = response.data.data;
      } catch (error) {
        this.compras = null;
        this.erroCompras =
          error?.response?.data?.message ||
          "Não foi possível consultar as compras do cliente agora.";
      } finally {
        this.carregandoCompras = false;
      }
    },
    alternarDetalhes(empresaId) {
      this.empresaDetalheId = this.empresaDetalheId === empresaId ? null : empresaId;
    },
    classeScore(nivel) {
      return {
        EXCELENTE: "text-success",
        BOM: "text-primary",
        REGULAR: "text-warning",
        BAIXO: "text-danger",
      }[nivel];
    },
    classeLabel(nivel) {
      return {
        EXCELENTE: "label-light-success",
        BOM: "label-light-primary",
        REGULAR: "label-warning",
        BAIXO: "label-danger",
      }[nivel];
    },
    varianteScore(nivel) {
      return {
        EXCELENTE: "success",
        BOM: "primary",
        REGULAR: "warning",
        BAIXO: "danger",
      }[nivel];
    },
    classeSituacaoRecompra(situacao) {
      return {
        RECOMPRA_PROVAVEL: "label-light-success",
        PROXIMA: "label-warning",
        PREVISTA: "label-light-primary",
      }[situacao];
    },
    classeTipoMovimento(origem) {
      return {
        NFE: "label-light-success",
        NFCE: "label-light-success",
        PRE_VENDA: "label-light-info",
        PEDIDO: "label-light-primary",
        ORCAMENTO: "label-light-warning",
        OS: "label-light-dark",
      }[origem] || "label-light";
    },
    identificacaoProduto(produto) {
      if (produto.cod_barras) return `Cód. barras: ${produto.cod_barras}`;
      if (produto.referencia) return `Referência: ${produto.referencia}`;
      if (produto.codigo) return `Código: ${produto.codigo}`;
      return "Sem identificação adicional";
    },
    chaveSugestao(sugestao) {
      const produto = sugestao.produto || {};
      return [produto.cod_barras, produto.referencia, produto.codigo, produto.descricao]
        .filter(Boolean)
        .join("-");
    },
    chaveHistorico(item) {
      return `${item.origem}-${item.id_documento || item.id_nfe}-${item.item_indice}-${this.chaveSugestao(item)}`;
    },
    formatarQuantidade(valor) {
      return Number(valor || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
      });
    },
    formatarMoeda(valor) {
      return Number(valor || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    formatarData(valor) {
      if (!valor) return "—";
      const partes = String(valor).slice(0, 10).split("-");
      return partes.length === 3 ? `${partes[2]}/${partes[1]}/${partes[0]}` : valor;
    },
    formatarDocumento(valor) {
      const documento = String(valor || "");
      if (/^\d{11}$/.test(documento)) {
        return documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
      if (/^\d{14}$/.test(documento)) {
        return documento.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
      return documento;
    },
  },
};
</script>

<style scoped>
.risco-cliente-grupo {
  display: inline-block;
  flex: 0 0 auto;
  margin-left: 0.35rem;
}

.cliente-risco-cabecalho,
.score-explicacao,
.titulos-detalhes td,
.recompra-ultima {
  background: #f8fafc;
}

.sugestao-recompra {
  border-left: 4px solid #3699ff !important;
}

.historico-pesquisa {
  min-width: 280px;
}

.score-valor {
  font-size: 3.25rem;
  font-weight: 700;
  line-height: 1;
}

.table td,
.table th {
  vertical-align: middle;
}
</style>

<style>
.risco-cliente-grupo-modal {
  overflow: hidden;
  padding: 0 !important;
}

.risco-cliente-grupo-modal .risco-cliente-grupo-dialog {
  bottom: 0;
  display: flex;
  height: calc(100vh - 2rem);
  left: 0;
  margin: 0;
  max-width: none;
  position: fixed;
  right: 0;
  width: 100%;
}

.risco-cliente-grupo-modal .risco-cliente-grupo-conteudo {
  border: 0;
  border-radius: 1rem 1rem 0 0;
  height: 100%;
  max-height: 100%;
  width: 100%;
}

.risco-cliente-grupo-modal .modal-body {
  overflow-y: auto;
}

.risco-cliente-grupo-modal.fade .modal-dialog {
  transform: translateY(100%);
}

.risco-cliente-grupo-modal.show .modal-dialog {
  transform: translateY(0);
}

.score-ajuda-popover {
  max-width: 380px;
}

@media (max-width: 767px) {
  .risco-cliente-grupo-modal .risco-cliente-grupo-dialog {
    height: calc(100vh - 1rem);
  }
}
</style>
